import type { WeaponDefinition } from '../types';

const SWORD: WeaponDefinition = {
  type: 'sword',
  displayName: 'Longsword',
  shape: {
    // Symmetric diamond cross-section, slight widening then taper to tip.
    // Drawn lengthwise; renderer handles orientation.
    vertices: [
      { x: 0.0, y: 0.05 },
      { x: 0.05, y: 0.07 },
      { x: 0.1, y: 0.09 },
      { x: 0.85, y: 0.09 },
      { x: 1.0, y: 0.0 },
      { x: 0.85, y: -0.09 },
      { x: 0.1, y: -0.09 },
      { x: 0.05, y: -0.07 },
      { x: 0.0, y: -0.05 },
    ],
  },
  quenchWindowWidth: 0.18,
  strikeDifficulty: 0.5,
  heatResolution: 24,
  killWindowWidth: 0.5,
  killWindowSpeed: 0.85,
};

const AXE: WeaponDefinition = {
  type: 'axe',
  displayName: 'Battle Axe',
  shape: {
    vertices: [
      { x: 0.0, y: 0.04 },
      { x: 0.6, y: 0.05 },
      { x: 0.7, y: 0.22 },
      { x: 1.0, y: 0.12 },
      { x: 1.0, y: -0.12 },
      { x: 0.7, y: -0.22 },
      { x: 0.6, y: -0.05 },
      { x: 0.0, y: -0.04 },
    ],
  },
  quenchWindowWidth: 0.26,
  strikeDifficulty: 0.3,
  heatResolution: 20,
  killWindowWidth: 0.7,
  killWindowSpeed: 0.55,
};

const SPEAR: WeaponDefinition = {
  type: 'spear',
  displayName: 'Spear',
  shape: {
    vertices: [
      { x: 0.0, y: 0.025 },
      { x: 0.7, y: 0.03 },
      { x: 0.78, y: 0.07 },
      { x: 1.0, y: 0.0 },
      { x: 0.78, y: -0.07 },
      { x: 0.7, y: -0.03 },
      { x: 0.0, y: -0.025 },
    ],
  },
  quenchWindowWidth: 0.12,
  strikeDifficulty: 0.8,
  heatResolution: 28,
  killWindowWidth: 0.25,
  killWindowSpeed: 1.4,
};

export const WEAPONS: Record<'sword' | 'axe' | 'spear', WeaponDefinition> = {
  sword: SWORD,
  axe: AXE,
  spear: SPEAR,
};
